module.exports = __webpack_public_path__ + "img/mycoach.d8ee0c60.svg";